<script>
  import { Breadcrumb, BreadcrumbItem, Col } from 'sveltestrap'
  import { Sveltestrap, Home, Library, NavBreadcrumb, NavBreadcrumbMessage } from '../../../utils/Constant/Constant';
  import Card from '../../Core/Card.svelte'
</script>

<Col sm="12">
  <Card headerTitle={NavBreadcrumb} cardHeaderprops="pb-0">
    <div slot="customheader">
      <span>{@html NavBreadcrumbMessage}</span>
    </div>
    <div slot="contentbody" >
      <Breadcrumb >
        <BreadcrumbItem>
          <a href="#home">{Home}</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <a href="#library">{Library}</a>
        </BreadcrumbItem>
        <BreadcrumbItem active>{Sveltestrap}</BreadcrumbItem>
      </Breadcrumb>
      <Breadcrumb style="--bs-breadcrumb-divider: '>';">
        <BreadcrumbItem>
          <a href="#home">{Home}</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <a href="#library">{Library}</a>
        </BreadcrumbItem>
        <BreadcrumbItem active>{Sveltestrap}</BreadcrumbItem>
      </Breadcrumb>
      <Breadcrumb style="--bs-breadcrumb-divider: '';" >
        <BreadcrumbItem>
          <a href="#home">{Home}</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <a href="#library">{Library}</a>
        </BreadcrumbItem>
        <BreadcrumbItem active>{Sveltestrap}</BreadcrumbItem>
      </Breadcrumb>
    </div>
  </Card>
</Col>
